import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { NavigationMemoryProvider } from '../../lib/navigationMemory';
import { AppSidebar } from './Sidebar';
import { TopBar } from './TopBar';

export function AppShell() {
  const { t } = useTranslation();
  return (
    <NavigationMemoryProvider>
    <TooltipProvider delayDuration={200}>
      <SidebarProvider>
        <a
          href="#main"
          className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-50 focus:rounded-md focus:bg-background focus:px-3 focus:py-2 focus:shadow"
        >
          {t('app.skip')}
        </a>
        <AppSidebar />
        {/* SidebarInset renders the <main> landmark. */}
        <SidebarInset id="main" tabIndex={-1} className="min-w-0 outline-none">
          <TopBar />
          <div className="mx-auto w-full max-w-[1440px] flex-1 px-4 py-6 md:px-6 lg:px-8">
            <Outlet />
          </div>
        </SidebarInset>
        <Toaster richColors closeButton />
      </SidebarProvider>
    </TooltipProvider>
    </NavigationMemoryProvider>
  );
}
